import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--enable-on-check"
export default class extends Controller {
  static targets = ["button"];
  static values = {
    disabledClass: String,
  };

  connect() {}

  toggle(e) {
    e.preventDefault();

    if (e.currentTarget.checked) {
      this.buttonTarget.classList.remove(this.disabledClassValue);
    } else {
      this.buttonTarget.classList.add(this.disabledClassValue);
    }
  }
}
